module.exports = __webpack_public_path__ + "media/images/covid/menu/hotel-252e537832a058126df0130cf612c35a.png";